/** On-chain USDT → TP recharge (legacy: 1 TP = exchange_rate USDT). */
export const TP_RECHARGE_CONFIG_KEYS = {
  MIN_USDT: 'recharge.tp_min_usdt',
  MIN_TP: 'recharge.tp_min_tp',
  EXCHANGE_RATE: 'recharge.tp_exchange_rate',
  ENABLED: 'recharge.tp_enabled',
  /** Auto-credit TP after on-chain tx verification. */
  AUTO_AUDIT: 'recharge.tp_auto_audit',
} as const;

export const TP_RECHARGE_DEFAULTS = {
  min_usdt: '100',
  min_tp: '100',
  exchange_rate: '1.14',
  enabled: 'true',
} as const;

/** Recharge TP in multiples of this step (UI presets include 100). */
export const TP_RECHARGE_STEP = 100;

/** On-chain USDT → RP (same placement table `php_uo_user_recharge_config` action=rp). */
export const RP_RECHARGE_CONFIG_KEYS = {
  MIN_RP: 'recharge.rp_min_rp',
  EXCHANGE_RATE: 'recharge.rp_exchange_rate',
  ENABLED: 'recharge.rp_enabled',
  AUTO_AUDIT: 'recharge.rp_auto_audit',
} as const;

export const RP_RECHARGE_DEFAULTS = {
  min_rp: '500',
  exchange_rate: '1.105',
  enabled: 'true',
} as const;

export const RP_RECHARGE_STEP = 500;

/** On-chain USDT → FC 燃料购买（价格 = USDT/FC，后台可调）。 */
export const FC_RECHARGE_CONFIG_KEYS = {
  MIN_FC: 'recharge.fc_min_fc',
  /** 13 USDT = 1 FC（默认，价格可调动）。 */
  EXCHANGE_RATE: 'recharge.fc_usdt_per_fc',
  ENABLED: 'recharge.fc_enabled',
  AUTO_AUDIT: 'recharge.fc_auto_audit',
} as const;

export const FC_RECHARGE_DEFAULTS = {
  min_fc: '1',
  exchange_rate: '13',
  enabled: 'true',
} as const;

/** FC 购买整数步进，最小 1 FC。 */
export const FC_RECHARGE_STEP = 1;
